// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1Bwfq","title":"AfterFrontImage_title__3f35L"};